import React, { useState, useEffect } from "react";
import "./DocUpload.css";
import Bin from "../../assets/img/delete_Icon.png";
import UploadIcon from "../../assets/img/upload-icon-blue.svg";
import RightArrowIcon from "../../assets/img/arrow-right-icon.png";
import UploadedDoc from "../../assets/img/uploaded-document.png";
import { FileUploader } from "react-drag-drop-files";
import RemoveIcon from "../../assets/img/X_Remove_Button.png";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ImagePopup from "../ImagePopup";
import Loader from "../Common/loader";
import {
  deleteSaveVisualData,
  getUploadFile,
  getVisualDoc,
  removeFile,
  saveVisualData,
  deleteGetVisualData,
} from "../../Actions/visualDocAction";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import GetMasterData from "../../Helper/masterData";
import { validateAlphabetsAndSpace } from "../../Helper/common";

function EventCoachFlow() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [visualData, setVisualData] = useState();
  const [secondUpload, setSecondUpload] = useState(false);
  const [thirdUpload, setThirdUpload] = useState(false);
  const [fileName1, setFileName1] = useState("");
  const [fileName2, setFileName2] = useState("");
  const [fileName3, setFileName3] = useState("");
  const [state, setState] = useState({});
  const [city, setCity] = useState({});
  const [editBankDetail, setEditBankDetail] = useState();
  const [errorData, setErrorData] = useState({});
  const [fileError, setFileError] = useState(false);
  const [url1, setUrl1] = useState();
  const [url2, setUrl2] = useState();
  const [url3, setUrl3] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const storeData2 = useSelector((state) => state.uploadVisDoc);
  const { loading: saveLoading, error: saveError } = storeData2;

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [saveLoading]);

  const handleOptionChange = (e) => {
    setErrorData({});

    for (let i in visualDocData.data.data.checksDetails[0].fields) {
      setEditBankDetail((prevState) => ({
        ...prevState,
        [visualDocData.data.data.checksDetails[0].fields[i].label]: "",
      }));
    }

    if (
      visualDocData.data?.data?.checksDetails[0].fields.select_service_type
        .field_value == e.target.value
    ) {
      for (let i in visualDocData.data?.data?.checksDetails[0].fields) {
        setEditBankDetail((prevState) => ({
          ...prevState,
          [visualDocData.data?.data?.checksDetails[0].fields[i].label]:
            visualDocData.data?.data?.checksDetails[0].fields[i].field_value,
        }));
      }
    }
    setEditBankDetail((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    setSelectedOption(e.target.value);
  };

  console.log("edi", editBankDetail);

  const { stateOptionspv, cityOptions } = GetMasterData();
  console.log(stateOptionspv);

  useEffect(() => {
    let obj = {};
    for (var i in stateOptionspv) {
      obj[stateOptionspv[i].label] = stateOptionspv[i].label;
    }
    setState(obj);
  }, [stateOptionspv]);


  const handleImageModal = (e, modalImage) => {
    e.preventDefault();
    e.stopPropagation();
    setImage(modalImage);
    setShowImageModal(!showImageModal);
  };

  const closePopup = () => {
    setImage("");
    setShowImageModal(false);
  };

  useEffect(() => {
    let obj = {};
    for (var i in cityOptions) {
      obj[cityOptions[i]] = cityOptions[i];
    }
    setCity(obj);
  }, [cityOptions]);

  const addDocModel = () => {
    // if (docModels.length < maxModels) {
    //   setDocModels([...docModels, docModels.length + 1]);
    // }
    if (secondUpload == false) {
      setSecondUpload(true);
    } else if (thirdUpload == false) {
      setThirdUpload(true);
    }
  };

  const storeData = useSelector((state) => state.visualDoc);
  const { visualDocData, loading: getDataLoading, error } = storeData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [role, setRole] = useState();
  const storeData1 = useSelector((state) => state.saveVisualDoc);
  const { saveVisualDocData, loading: getDataLoad, err } = storeData1;

  useEffect(() => {
    const fetchData = async () => {
      let formData = {};
      formData.group = 21;
      const currentUrl = window.location.href;
      const [partA, partB] = currentUrl.split("/check-detail/");
      const [reference, route] = partB.split("/");
      formData.referenceNo = reference;
      dispatch(getVisualDoc(formData));
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (
      typeof visualDocData.data !== "undefined" &&
      visualDocData.data !== null
    ) {
      if (visualDocData.data?.data?.checksDetails[0].fields) {
        for (let i in visualDocData.data?.data?.checksDetails[0].fields) {
          if (
            visualDocData.data?.data?.checksDetails[0].fields[i]
              .field_input_type == 5
          ) {
            setSelectedOption(
              visualDocData.data?.data?.checksDetails[0].fields[i].field_value
            );
          }

          setEditBankDetail((prevState) => ({
            ...prevState,
            [visualDocData.data?.data?.checksDetails[0].fields[i].label]:
              visualDocData.data?.data?.checksDetails[0].fields[i].field_value,
          }));
        }

        for (let i in visualDocData.data?.data?.checksDetails[0]
          ?.uploaded_documents) {
          if (
            visualDocData.data?.data?.checksDetails[0]?.uploaded_documents[i]
              .master_docid == 309
          ) {
            setFileName1(
              visualDocData.data?.data?.checksDetails[0].uploaded_documents[i]
                .file_name
            );
            setUrl1(
              visualDocData.data?.data?.checksDetails[0].uploaded_documents[i]
                .preview_key
            );
          } else if (
            visualDocData.data?.data?.checksDetails[0]?.uploaded_documents[i]
            .master_docid == 310
          ) {
            setSecondUpload(true);
            setFileName2(
              visualDocData.data?.data?.checksDetails[0]?.uploaded_documents[i]
                ?.file_name
            );
            setUrl2(
              visualDocData.data?.data?.checksDetails[0].uploaded_documents[i]
                .preview_key
            );
          } else if (
            visualDocData.data?.data?.checksDetails[0]?.uploaded_documents[i]
            .master_docid == 311
          ) {
            setThirdUpload(true);
            setFileName3(
              visualDocData.data?.data?.checksDetails[0]?.uploaded_documents[i]
                ?.file_name
            );
            setUrl3(
              visualDocData.data?.data?.checksDetails[0].uploaded_documents[i]
                .preview_key
            );
          }
        }
      }
    }
  }, [visualDocData, storeData]);

  useEffect(() => {
    if (
      typeof saveVisualDocData.data !== "undefined" &&
      saveVisualDocData.data !== null
    ) {
      if (saveVisualDocData.data.group.group_id == "profile_preview") {
        navigate(
          `/case-initiation/profile-preview/${saveVisualDocData.data.reference_number}`
        );
        dispatch(deleteSaveVisualData());
      } else {
        navigate(
          `/case-initiation/check-detail/${saveVisualDocData.data.reference_number}/${saveVisualDocData.data.group.group_id}`
        );
        dispatch(deleteSaveVisualData());
      }
    }
  }, [saveVisualDocData, storeData1]);

  useEffect(() => {
    if (
      typeof visualDocData.data !== "undefined" &&
      visualDocData.data !== null
    ) {
      setVisualData(visualDocData.data.data.checksDetails[0].fields);
    }
  }, [visualDocData, storeData]);

  const removeDocModel = (index) => {
    // const updatedModels = docModels.filter((_, i) => i !== index);
    // setDocModels(updatedModels);
    if (index == "2") {
      handleTrashClick("2");
      setSecondUpload(false);
    } else if (index == "3") {
      handleTrashClick("3");
      setThirdUpload(false);
    }
  };

  const renderDragDropChildren = () => (
    <>
      <input type="file" id="myFile" class="mt-2" name="filename" />

      <div className="row uploadBox justify-content-around border rounded w-100 ml-1">
        <div className="col-2 align-self-center">
          <img src={UploadIcon} alt="UploadIcon" width="32px" height="32px" />
        </div>
        <div className="col-8 align-self-center">
          <div className="row uploadCardText1">
            Upload Sport Certification <sup className="text-danger">*</sup>
          </div>
          <div className="row uploadCardText2">
            upload PNG, JPG, JPEG, PDF (max file size 5mb)
          </div>
        </div>
        <div className="col-1 align-self-center">
          <img
            src={RightArrowIcon}
            alt="RightArrowIcon"
            width="5px"
            height="10px"
          />
        </div>
      </div>

      {/* <div class="w-100 bg-gray p-5 mb-3 text-center file-upload">
        <ul class="mt-4">
          <li>
            <i data-feather="upload-cloud">
            
            </i>
          </li>
          <li class="mt-4">
           
            <p class="fnt-14 text-primary" style={{ cursor: "pointer" }}>
              Click to upload <span class="text-gray">or drag and drop</span>
            </p>
          </li>
          <li class="fnt-12 text-gray">XLS or CSV File (max. 5mb)</li>
        </ul>
      </div> */}
    </>
  );

  const handleChange = async (file) => {
    let fil = file.name.lastIndexOf(".") + 1;
    let fileType = file.name.substring(fil);

    if (fileType !== "png" && fileType !== "jpg" && fileType !== "jpeg" && fileType !== "pdf" &&
    fileType !== "PNG" &&
    fileType !== "JPG" &&
    fileType !== "PDF" &&
    fileType !== "JPEG"
    ) {
      alert("Wrong file format");
      return false;
    }

    if (file.size > 5242880) {
      alert("File cannot be larger than 5mb");
      return false;
    }
    setFileName1(file.name);
    setFileError(false);
    let record = {};
    record.mode = "check_documents";
    record.chkid = visualDocData.data.data.checksDetails[0].case_check_id;
   // record.docid = 309;
   record.docid = visualDocData.data.data.checksDetails[0].required_documents[0].id;
    record.check_documents = [file];
    let dat = await dispatch(getUploadFile(record, file));
    setUrl1(dat.data[0].preview_key);
    // let formData = {};
    // formData.group = 21;
    // const currentUrl = window.location.href;
    // const [partA, partB] = currentUrl.split("/check-detail/");
    // const [reference, route] = partB.split("/");
    // formData.referenceNo = reference;
    // dispatch(getVisualDoc(formData));
  };

  const handleTrashClick = (val) => {
    if (val == "2") {
      setFileName2("");
      let record = {};
      record.mode = "check_documents";
      record.doc_ref = "all";
      record.doc_chk = visualDocData?.data?.data.checksDetails[0].case_check_id;
    //  record.doc_ids = 310;
    record.doc_ids = visualDocData.data.data.checksDetails[0].required_documents[1].id;
      dispatch(removeFile(record));
    } else if (val == "3") {
      setFileName3("");
      let record = {};
      record.mode = "check_documents";
      record.doc_ref = "all";
      record.doc_chk = visualDocData.data.data.checksDetails[0].case_check_id;
     // record.doc_ids = 311;
     record.doc_ids = visualDocData.data.data.checksDetails[0].required_documents[2].id;
      dispatch(removeFile(record));
    } else {
      setFileName1("");
      let record = {};
      record.mode = "check_documents";
      record.doc_ref = "all";
      record.doc_chk = visualDocData.data.data.checksDetails[0].case_check_id;
      //record.doc_ids = 309;
      record.doc_ids = visualDocData.data.data.checksDetails[0].required_documents[0].id;
      dispatch(removeFile(record));
    }
  };

  const handleChange2 = async (file) => {
    let fil = file.name.lastIndexOf(".") + 1;
    let fileType = file.name.substring(fil);

    if (fileType !== "png" && fileType !== "jpg" && fileType !== "jpeg" && fileType !== "pdf" &&
    fileType !== "PNG" &&
    fileType !== "JPG" &&
    fileType !== "PDF" &&
    fileType !== "JPEG") {
      alert("Wrong file format");
      return false;
    }

    if (file.size > 5242880) {
      alert("File cannot be larger than 5mb");
      return false;
    }
    setFileName2(file.name);
    let record = {};
    record.mode = "check_documents";
    record.chkid = visualDocData.data.data.checksDetails[0].case_check_id;
   // record.docid = 310;
   record.docid = visualDocData.data.data.checksDetails[0].required_documents[1].id;
    record.check_documents = [file];
    let dat1 = await dispatch(getUploadFile(record, file));
    setUrl2(dat1.data[0].preview_key);
    // let formData = {};
    // formData.group = 21;
    // const currentUrl = window.location.href;
    // const [partA, partB] = currentUrl.split("/check-detail/");
    // const [reference, route] = partB.split("/");
    // formData.referenceNo = reference;
    // dispatch(getVisualDoc(formData));
  };

  const handleChange3 = async (file) => {
    let fil = file.name.lastIndexOf(".") + 1;
    let fileType = file.name.substring(fil);

    if (fileType !== "png" && fileType !== "jpg" && fileType !== "jpeg" && fileType !== "pdf" && 
    fileType !== "PNG" &&
    fileType !== "JPG" &&
    fileType !== "PDF" &&
    fileType !== "JPEG") {
      alert("Wrong file format");
      return false;
    }

    if (file.size > 5242880) {
      alert("File cannot be larger than 5mb");
      return false;
    }
    setFileName3(file.name);

    let record = {};
    record.mode = "check_documents";
    record.chkid = visualDocData.data.data.checksDetails[0].case_check_id;
   // record.docid = 311;
   record.docid = visualDocData.data.data.checksDetails[0].required_documents[2].id;
    record.check_documents = [file];

    let dat3 = await dispatch(getUploadFile(record, file));
    setUrl3(dat3.data[0].preview_key);
    // let formData = {};
    // formData.group = 21;
    // const currentUrl = window.location.href;
    // const [partA, partB] = currentUrl.split("/check-detail/");
    // const [reference, route] = partB.split("/");
    // formData.referenceNo = reference;
    // dispatch(getVisualDoc(formData));
  };

  const handleOnChange = (e) => {
    console.log(e.target.name);

      setErrorData((prevState) => ({
        ...prevState,
        [e.target.name]:
          e.target.value === ""
            ? true
            : !validateAlphabetsAndSpace(e.target.value),
      }));

    setEditBankDetail((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  const handleSave = (e) => {
    setErrorData({});
    e.preventDefault();
    let hasError = false;
    for (let i in visualDocData?.data?.data?.checksDetails[0].fields) {
      if (
        editBankDetail[
          visualDocData.data.data.checksDetails[0].fields[i].label
        ] == "" ||
        editBankDetail[
          visualDocData.data.data.checksDetails[0].fields[i].label
        ] === null
      ) {
        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [visualDocData.data.data.checksDetails[0].fields[i].label]: true,
        }));
      }
    }

    console.log(errorData);

    if (selectedOption == "coaching" && fileName1 == "") {
      hasError = true;
      setFileError(true);
    }
    for (var i in errorData) {
      if (errorData[i] == true) {
        hasError = true;
        break;
      }
    }
    if (hasError) {
      return;
    }

    let record = {};
    const formData = getFormData();
    record.check_data = { ...formData };
    record.case_check_id =
      visualDocData.data.data.checksDetails[0].case_check_id;
    console.log(record);
    console.log(selectedOption);

    if (selectedOption == "events") {
      let record = {};
      record.mode = "check_documents";
      record.doc_ref = "all";
      record.doc_chk = visualDocData.data.data.checksDetails[0].case_check_id;
     // record.doc_ids = 309;
     record.doc_ids = visualDocData.data.data.checksDetails[0].required_documents[0].id;
      let val = false;
      dispatch(removeFile(record, val));

      let record2 = {};
      record2.mode = "check_documents";
      record2.doc_ref = "all";
      record2.doc_chk = visualDocData.data.data.checksDetails[0].case_check_id;
      //record2.doc_ids = 310;
      record2.doc_ids = visualDocData.data.data.checksDetails[0].required_documents[1].id;
  
      dispatch(removeFile(record2, val));

      let record3 = {};
      record3.mode = "check_documents";
      record3.doc_ref = "all";
      record3.doc_chk = visualDocData.data.data.checksDetails[0].case_check_id;
      //record3.doc_ids = 311;
     record3.doc_ids = visualDocData.data.data.checksDetails[0].required_documents[2].id;

      dispatch(removeFile(record3, val));
    }

    dispatch(saveVisualData(record));
    dispatch(deleteGetVisualData());
  };

  const getFormData = () => {
    const formData = {};
    let data = {};
    for (var i in visualDocData.data?.data?.checksDetails[0].fields) {
      if (
        visualDocData.data?.data?.checksDetails[0].fields[i].field_input_type ==
        5
      ) {
        formData[
          `${visualDocData.data?.data?.checksDetails[0].fields[i].ibridge_field_id}`
        ] = selectedOption;
      } else {
        formData[
          `${visualDocData.data?.data?.checksDetails[0].fields[i].ibridge_field_id}`
        ] =
          editBankDetail[
            visualDocData.data?.data?.checksDetails[0].fields[i].label
          ];
      }
    }
    formData.group = "visual_document";
    data[visualDocData.data.data.checksDetails[0].case_check_id] = {
      ...formData,
    };
    return data;
  };

  const handleInputChange = (e) => {
    switch (e.target.name) {
      case "Preferred Sport":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]:
            e.target.value === ""
              ? true
              : !validateAlphabetsAndSpace(e.target.value),
        }));
        break;
    }
    setEditBankDetail((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="myCard">
        <div className="row">
          <div className="col-lg-9 col-md-12 col-sm-12">
            <div className="row card-header d-flex flex-column p-3">
              <div className="row1 col">Visual Document</div>
            </div>

            <div className="card-body px-0">
              <div className="row py-3 pt-4 ServiceType-Head">
                Select your Service type?
              </div>
              <div className="form-check row">
                <input
                  type="radio"
                  className="form-check-input"
                  id="eventsRadio"
                  value="events"
                  name="Select Your Service Type ?"
                  checked={selectedOption === "events"}
                  onChange={handleOptionChange}
                />
                <label
                  className="form-check-label ml-3"
                  style={{ paddingTop: "2px" }}
                  htmlFor="eventsRadio"
                >
                  Events
                </label>
              </div>

              <div className="form-check mt-2 row">
                <input
                  type="radio"
                  className="form-check-input"
                  name="Select Your Service Type ?"
                  id="coachingRadio"
                  value="coaching"
                  checked={selectedOption === "coaching"}
                  onChange={handleOptionChange}
                />
                <label
                  className="form-check-label ml-3"
                  style={{ paddingTop: "2px" }}
                  htmlFor="coachingRadio"
                >
                  Coaching
                </label>
              </div>

              {selectedOption && (
                <div className="my-3">
                  <div
                    className="row"
                    style={{
                      color: "var(--gray-900, #101828)",
                      fontFamily: "Inter-Regular",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "38px",
                    }}
                  >
                    Please fill required details
                  </div>
                  <div className="row my-3">
                    <form>
                      <div className="form-row">
                        {visualData &&
                          Object.entries(visualData).map((val, index) => {
                            if (val[1].label == "Select Your Service Type ?") {
                            } else {
                              return (
                                <>
                                  <div className="form-group col-md-4">
                                    {val[1].field_input_type == 1 ? (
                                      <>
                                        <label for="inputSport form-label">
                                          {val[1].label}
                                          <sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control form-placeholder pl-2"
                                          name={val[1].label}
                                          value={editBankDetail[val[1].label]}
                                          placeholder={`Enter ${val[1].label}`}
                                          id="inputSport"
                                          onChange={handleInputChange}
                                        />
                                        {errorData[val[1].label] === true ? (
                                          editBankDetail[val[1].label] === "" ||
                                          editBankDetail[val[1].label] ===
                                            null ? (
                                            <p className="text-danger">
                                              This is a required field.
                                            </p>
                                          ) : (
                                            <p className="text-danger">
                                              Please provide valid input
                                            </p>
                                          )
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {val[1].label == "Preferred State" ? (
                                          <>
                                            {" "}
                                            <label for="inputSport form-label">
                                              {val[1].label}
                                              <sup className="text-danger">
                                                *
                                              </sup>
                                            </label>
                                            <select
                                              name={val[1].label}
                                              value={
                                                editBankDetail[val[1].label]
                                              }
                                              id={val[1].ibridge_field_id}
                                              className="form-control"
                                              onChange={(e) =>
                                                handleOnChange(e)
                                              }
                                              // data-checkdetailsindex={checkDetailsIndex}
                                              // data-fieldname={fieldName}
                                              style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              }}
                                            >
                                              <option value="">
                                                Select State from here
                                              </option>
                                              {state &&
                                                Object.entries(state).map(
                                                  (option) => {
                                                    return (
                                                      <option
                                                        value={option[0]}
                                                        selected={
                                                          val[1].field_value ==
                                                          option[0]
                                                            ? true
                                                            : false
                                                        }
                                                      >
                                                        {option[1]}
                                                      </option>
                                                    );
                                                  }
                                                )}
                                            </select>
                                            {errorData[val[1].label] ===
                                            true ? (
                                              editBankDetail[val[1].label] ===
                                                "" ||
                                              editBankDetail[val[1].label] ===
                                                null ? (
                                                <p className="text-danger">
                                                  This is a required field.
                                                </p>
                                              ) : (
                                                ""
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {val[1].label ==
                                            "Preferred City" ? (
                                              <>
                                                <label for="inputSport form-label">
                                                  {val[1].label}
                                                  <sup className="text-danger">
                                                    *
                                                  </sup>
                                                </label>
                                                <select
                                                  name={val[1].label}
                                                  value={
                                                    editBankDetail[val[1].label]
                                                  }
                                                  id={val[1].ibridge_field_id}
                                                  className="form-control"
                                                  onChange={(e) =>
                                                    handleOnChange(e)
                                                  }
                                                  // data-checkdetailsindex={checkDetailsIndex}
                                                  // data-fieldname={fieldName}
                                                  style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                >
                                                  <option value="">
                                                    Select City from here
                                                  </option>
                                                  {city &&
                                                    Object.entries(city).map(
                                                      (option) => {
                                                        return (
                                                          <option
                                                            value={option[0]}
                                                            selected={
                                                              val[1]
                                                                .field_value ==
                                                              option[0]
                                                                ? true
                                                                : false
                                                            }
                                                          >
                                                            {option[0]}
                                                          </option>
                                                        );
                                                      }
                                                    )}
                                                </select>
                                                {errorData[val[1].label] ===
                                                true ? (
                                                  editBankDetail[
                                                    val[1].label
                                                  ] === "" ||
                                                  editBankDetail[
                                                    val[1].label
                                                  ] === null ? (
                                                    <p className="text-danger">
                                                      This is a required field.
                                                    </p>
                                                  ) : (
                                                    ""
                                                  )
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </>
                              );
                            }
                          })}
                        {/* <div className="form-group col-md-4">
                    <label for="inputSport form-label">Preferred Sport</label>
                    <input
                      type="text"
                      className="form-control form-placeholder pl-2"
                      placeholder="Enter Prefered Sport"
                      id="inputSport"
                    />
                  </div>
                  <div className="form-group col-md-4">
                    <label for="inputState form-label">Preferred State</label>
                    <div className="d-flex">
                      <i className="fas fa-search search-icon" />
                      <input
                        type="text"
                        className="form-control form-placeholder"
                        placeholder="Enter Prefered State"
                        id="inputState"
                      />
                    </div>
                  </div>
                  <div className="form-group col-md-4">
                    <label for="inputCity form-label">Preferred City</label>
                    <div className="d-flex">
                      <i className="fas fa-search search-icon" />
                      <input
                        type="text"
                        className="form-control form-placeholder"
                        placeholder="Enter Prefered City"
                        id="inputCity"
                      />
                    </div>
                  </div> */}
                      </div>
                    </form>
                  </div>

                  {selectedOption === "coaching" && (
                    <div className="row my-3 d-flex justify-content-center align-items-start flex-column w-100">
                      <div className="form-group col-lg-6 col-md-12 col-sm-12 p-0">
                        <div
                          className="col-12 p-0"
                          style={{
                            color: "var(--gray-800, #1D2939)",
                            fontFamily: "Inter-Regular",
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "normal",
                          }}
                        >
                          Upload Sport Certificate
                        </div>

                        {/* <div className="row justify-content-between w-100">
                        <div className="col-8 docTitle">Upload Document 1</div>
                      </div> */}
                        {fileName1 == "" ? (
                          <>
                            <FileUploader
                              hoverTitle={"Choose Files"}
                              classes={"file-upload w-100 border-0"}
                              handleChange={handleChange}
                              multiple={false}
                              name="file"
                              children={renderDragDropChildren()}
                              onSizeError={(file) => {
                                alert("file size larger than 5 mb");
                              }}
                              onClick={(e) => (e.target.value = null)}
                            />
                            {fileError ? (
                              <p className="text-danger">
                                This is a required field.
                              </p>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <>
                            <div
                              style={{
                                cursor: "pointer",
                                borderRadius: "4px",
                                border: "1px solid var(--gray-300, #D0D5DD)",
                                background: "var(--White, #FFF)",
                              }}
                              className="col-12 d-flex align-items-center justify-content-center bg-white uploadedDoc my-2 px-3"
                            >
                              <img
                                src={url1}
                                style={{
                                  maxWidth: "50px",
                                  width: "100%",
                                  maxHeight: "50px",
                                  objectFit: "contain",
                                }}
                                alt="UploadedDoc"
                              />
                              <div className="d-flex align-items-center justify-content-between w-100 mx-3">
                                <p
                                  className="text-truncate pt-3"
                                  style={{
                                    maxWidth: 200,
                                  }}
                                >
                                  {fileName1}
                                </p>
                                <i
                                      className="fas fa-eye text-muted mr-3 cursor-pointer"
                                      onClick={(e) => handleImageModal(e, url1)}
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      style={{
                                        maxWidth: "12px",
                                        width: "100%",
                                      }}
                                      title="View"
                                    ></i>
                                <img
                                  src={Bin}
                                  onClick={() => handleTrashClick("1")}
                                  alt="Delete"
                                  style={{ maxWidth: "15px", width: "100%" }}
                                />
                              </div>
                            </div>
                          </>
                        )}

                        {secondUpload ? (
                          <>
                            <div className="row justify-content-between w-100">
                              <div className="col-8 docTitle">
                                Upload Document 2
                              </div>
                              <div className="col-4 cursor-pointer d-flex justify-content-end">
                                <img
                                  src={RemoveIcon}
                                  alt="RemoveIcon"
                                  onClick={() => removeDocModel("2")}
                                />
                              </div>
                            </div>
                            {fileName2 == "" ? (
                              <FileUploader
                                hoverTitle={"Choose Files"}
                                classes={"file-upload w-100 border-0"}
                                handleChange={handleChange2}
                                multiple={false}
                                name="file"
                                children={renderDragDropChildren()}
                                onSizeError={(file) => {
                                  alert("file size larger than 5 mb");
                                }}
                                onClick={(e) => (e.target.value = null)}
                              />
                            ) : (
                              <>
                                <div
                                  style={{
                                    cursor: "pointer",
                                    borderRadius: "4px",
                                    border:
                                      "1px solid var(--gray-300, #D0D5DD)",
                                    background: "var(--White, #FFF)",
                                  }}
                                  className="col-12 d-flex align-items-center justify-content-center bg-white uploadedDoc my-2 px-3"
                                >
                                  <img
                                    src={url2}
                                    alt="UploadedDoc"
                                    style={{
                                      maxWidth: "50px",
                                      width: "100%",
                                      maxHeight: "50px",
                                      objectFit: "contain",
                                    }}
                                  />
                                  <div className="d-flex align-items-center justify-content-between w-100 mx-3">
                                    <p
                                      className="text-truncate pt-3"
                                      style={{
                                        maxWidth: 200,
                                      }}
                                    >
                                      {fileName2}
                                    </p>
                                    <i
                                      className="fas fa-eye text-muted mr-3 cursor-pointer"
                                      onClick={(e) => handleImageModal(e, url2)}
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      style={{
                                        maxWidth: "12px",
                                        width: "100%",
                                      }}
                                      title="View"
                                    ></i>
                                    <img
                                      src={Bin}
                                      onClick={() => handleTrashClick("2")}
                                      alt="Delete"
                                      style={{
                                        maxWidth: "15px",
                                        width: "100%",
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          ""
                        )}

                        {thirdUpload ? (
                          <>
                            <div className="row justify-content-between w-100">
                              <div className="col-8 docTitle">
                                Upload Document 3
                              </div>
                              <div className="col-4 cursor-pointer d-flex justify-content-end">
                                <img
                                  src={RemoveIcon}
                                  alt="RemoveIcon"
                                  onClick={() => removeDocModel("3")}
                                />
                              </div>
                            </div>
                            {fileName3 == "" ? (
                              <FileUploader
                                hoverTitle={"Choose Files"}
                                classes={"file-upload w-100 border-0"}
                                handleChange={handleChange3}
                                multiple={false}
                                name="file"
                                children={renderDragDropChildren()}
                                onSizeError={(file) => {
                                  alert("file size larger than 5 mb");
                                }}
                                onClick={(e) => (e.target.value = null)}
                              />
                            ) : (
                              <>
                                <div
                                  style={{
                                    cursor: "pointer",
                                    borderRadius: "4px",
                                    border:
                                      "1px solid var(--gray-300, #D0D5DD)",
                                    background: "var(--White, #FFF)",
                                  }}
                                  className="col-12 d-flex align-items-center justify-content-center bg-white uploadedDoc my-2 px-3"
                                >
                                  <img
                                    src={url3}
                                    alt="UploadedDoc"
                                    style={{
                                      maxWidth: "50px",
                                      width: "100%",
                                      maxHeight: "50px",
                                      objectFit: "contain",
                                    }}
                                  />
                                  <div className="d-flex align-items-center justify-content-between w-100 mx-3">
                                    <p
                                      className="text-truncate pt-3"
                                      style={{
                                        maxWidth: 200,
                                      }}
                                    >
                                      {fileName3}
                                    </p>
                                    <i
                                      className="fas fa-eye text-muted mr-3 cursor-pointer"
                                      onClick={(e) => handleImageModal(e, url3)}
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      style={{
                                        maxWidth: "12px",
                                        width: "100%",
                                      }}
                                      title="View"
                                    ></i>
                                    <img
                                      src={Bin}
                                      onClick={() => handleTrashClick("3")}
                                      alt="Delete"
                                      style={{
                                        maxWidth: "15px",
                                        width: "100%",
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          ""
                        )}

                        {showImageModal && (
                          <ImagePopup
                            showModalBox={1}
                            title={"Uploaded file"}
                            description={"..."}
                            isAdd={true}
                            image={image}
                            closePopup={closePopup}
                          />
                        )}


                      { secondUpload && thirdUpload ?  '' :<div className="btnRow row m-2 ml-0 py-3">
                          <button
                            className="btn btn-primary addBtn"
                            onClick={addDocModel}
                          >
                            + Add “upload Document”
                          </button>
                        </div>}
                      </div>
                    </div>
                  )}

                  <div className="row d-flex justify-content-start align-items-start my-5">
                    {/* <button className="btn btn-outline-secondary mr-2">Back</button> */}
                    <button
                      className="btn btn-primary ml-2"
                      onClick={handleSave}
                    >
                      Continue
                    </button>
                  </div>
                  {visualDocData?.data?.data?.showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EventCoachFlow;
